import { selectCommonality, type SelectCommonalityRequest } from '@/entities/discovery';
import { useAbortableMutation } from '@/shared/hooks/use-abortable-mutation';

import { searchCreatorPendingAtom } from '../stores/mutation-atom';

type SelectCommonalityMutationRequest = {
  discoverySessionId: string;
  request: SelectCommonalityRequest;
};

export function useSelectCommonality() {
  return useAbortableMutation({
    mutationFn: ({ discoverySessionId, request }: SelectCommonalityMutationRequest, signal) =>
      selectCommonality(discoverySessionId, request, signal),
    scope: { id: 'discovery:chat' },
    pendingAtom: searchCreatorPendingAtom,
    requestKey: 'discovery:select-commonality',
  });
}
